<script>
import ReportingApi from "@/services/reporting-api";

export default {

    props: {
      countCollectingDataByDay: {
        type: Object,
        default: () => null,
      },
    title: {
          type: String,
          default: () => '',
      },
      name: {
          type: String,
          default: () => '',
      },
      campaignId: {
            type: Number,
            default: null,
        },

    },

    data(){
        return{
            chartOptions : {},
            pageChart:1,
            apexChartsBarArea:0,
            pageSize:10
        }
    },

    mounted(){
      if(this.countCollectingDataByDay && this.countCollectingDataByDay.date && this.countCollectingDataByDay.countByDay   ){
        this.renderBarChart()
      }
    },

  watch:{
    countCollectingDataByDay:function(){
        if(this.countCollectingDataByDay && this.countCollectingDataByDay.date && this.countCollectingDataByDay.countByDay   ){
        this.renderBarChart()
      }
    },
    pageSize:function(){
      this.getDataByPageSize()
    }
  },

  methods:{

      getDataByPageSize(){
      ReportingApi.getCollectingDataPerDay(this.pageChart, this.campaignId, this.pageSize).then(result => {
          if(result){
              this.chartOptions = {
              series: [{
                name: this.name,
                data: result.countByDay
              }],
              chart: {
                toolbar: {
                show: true,
                tools: {
                  download: true,
                  selection: false, 
                  zoom: false,
                  zoomin: false, 
                  zoomout: false,
                  pan: false,
                  reset: true
                },
              },
                    height: '350'
                },
              dataLabels: {
                enabled: false,
              },
              stroke: {
                curve: 'smooth'
              },
              
              xaxis: {
                type: 'string',
                categories: result.date
              },
              legend: {
                show: true,
              },

              responsive: [{
                breakpoint: 768,
                options: {
                  chart: {
                    toolbar: {
                      show: false
                    }
                  }
                }
              }]
            };
              this.apexChartsBarArea ++;
          }else if((result == null || result.length == 0) && (this.pageChart -1) ==1){
            this.chartOptions = {}
          }
      })
    },


    nextPage(){

    ReportingApi.getCollectingDataPerDay(this.pageChart + 1, this.campaignId, this.pageSize).then(result => {
        if(result){
            this.pageChart ++;
            this.chartOptions = {
            series: [{
              name: this.name,
              data: result.countByDay
            }],
            chart: {
              toolbar: {
              show: true,
              tools: {
                download: true,
                selection: false, 
                zoom: false,
                zoomin: false, 
                zoomout: false,
                pan: false,
                reset: true
              },
            },
                  height: '350'
              },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: 'smooth'
            },
            
            xaxis: {
              type: 'string',
              categories: result.date
            },
            legend: {
              show: true,
            },

            responsive: [{
              breakpoint: 768,
              options: {
                chart: {
                  toolbar: {
                    show: false
                  }
                }
              }
            }]
          };
            this.apexChartsBarArea ++;
        }else if((result == null || result.length == 0) && (this.pageChart -1) ==1){
          this.chartOptions = {}
        }
    })
    },

    previousPage(){
    ReportingApi.getCollectingDataPerDay(this.pageChart - 1 , this.campaignId, this.pageSize).then(result => {
        if(result){
            this.pageChart -- ;
            this.chartOptions = {
            series: [{
              name: this.name,
              data: result.countByDay
            }],
            chart: {
              toolbar: {
              show: true,
              tools: {
                download: true,
                selection: false, 
                zoom: false,
                zoomin: false, 
                zoomout: false,
                pan: false,
                reset: true
              },
            },
                  height: '350'
              },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: 'smooth'
            },
            
            xaxis: {
              type: 'string',
              categories: result.date
            },
            legend: {
              show: true,
            },

            responsive: [{
              breakpoint: 768,
              options: {
                chart: {
                  toolbar: {
                    show: false
                  }
                }
              }
            }]
          };
            this.apexChartsBarArea ++;

        }else if((result == null || result.length == 0) && (this.pageChart -1)  ==1){
          this.chartOptions = {}
        }

    })
    },



    
    renderBarChart() {
      this.chartOptions = {
        series: [{
          name: this.name,
          data: this.countCollectingDataByDay.countByDay
        }],
        chart: {
          toolbar: {
          show: true,
          tools: {
            download: true,
            selection: false, 
            zoom: false,
            zoomin: false, 
            zoomout: false,
            pan: false,
            reset: true
          },
        },
              height: '350'
          },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth'
        },
        
        xaxis: {
          type: 'string',
          categories: this.countCollectingDataByDay.date
        },
        legend: {
          show: true,
        },

        responsive: [{
          breakpoint: 768,
          options: {
            chart: {
              toolbar: {
                show: false
              }
            }
          }
        }]
      };



  }
  }
  
};
</script>

<template>
  
      <div class="card h-100"  style="border:1px solid #ddd;">
        <div class="card-body " >



          <div class="row">
            
                <div class="col-md-6 col-12">
                    <h4 class="text-dark text-uppercase font-weight-bold">{{ title }}</h4>
                </div>

                <div class="col-md-6 col-12 d-flex justify-content-end">
                  <div>
                    <img alt="left" class="mr-2" width="17px" src="@/assets/icons/left-2.svg" style="cursor: pointer;" @click="nextPage()" />
                    <span class="text-center mr-2">page {{pageChart}}</span>              
                    <img alt="right" width="17px" src="@/assets/icons/right-2.svg" style="cursor: pointer; " @click="previousPage()"  :style="{ opacity: pageChart === 1 ? 0.5 : 1, pointerEvents: pageChart === 1 ? 'none' : 'auto' }"                    />
                  </div>
                  <div>
                    <select class="custom-select custom-select-sm ml-2"  v-model="pageSize">
                      <option selected value="10">10</option>
                      <option value="30">30</option>
                    </select>
                  </div>
                </div>
            </div>


        <apexchart :key="apexChartsBarArea" v-if="chartOptions && chartOptions.series && chartOptions.series.length " type="area" height="340" :options="chartOptions" :series="chartOptions.series"></apexchart>
        <div v-else class="d-flex justify-content-center align-items-center text-secondary h-100" style="min-height:340px;" >Pas de collecte de données</div>
      </div>  
      </div>  
</template>